import { Injectable } from '@angular/core';
// LIBS
import { BehaviorSubject, Observable } from 'rxjs';
// SERVICES
import { LocalStorageService } from '@services/storage/local-storage.service';
// MODELS
import { User } from '@models/authentication/User';
// CONST / UTILS
import { STORAGE_KEYS } from '@constants/StorageKeys';
import { Router } from '@angular/router';
import { ThemeService } from "@services/configuration/theme.service";
import { MatDialog } from '@angular/material/dialog';
import { UserConfigurationService } from '../user/user-configuration.service';
import { getSystem } from '@utils/system';
import { SYSTEMS } from '@constants/System';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationConfigurationService {
  private currentUserSubject: BehaviorSubject<any>;
  public currentUser: Observable<User>;

  constructor(
    private storageService: LocalStorageService,
    private router: Router,
    private userConfigurationService: UserConfigurationService,
    private themeService: ThemeService,
    private dialog: MatDialog,
  ) {
    this.currentUserSubject = new BehaviorSubject<User>(this.getUser());
    this.currentUser = this.currentUserSubject.asObservable();
  }

  setUp(user: User) {
    this.themeService.setUp(user.systemId);
    this.currentUserSubject.next(user);
    this.storageService.storeObject(STORAGE_KEYS.USER, user);
  }

  clear() {
    this.redirectToLogin();
    this.dialog.closeAll();
    this.storageService.remove(STORAGE_KEYS.USER);
    this.currentUserSubject.next(null);
    this.userConfigurationService.clear();
  }

  redirectToLogin() {
    const {systemId} = this.getUser() || {};
    const {login} = getSystem(systemId);
    setTimeout(() => this.router.navigate([login], { replaceUrl: true }), 200);
  }

  redirectToHome() {
    this.router.navigate(['/app/home'], { replaceUrl: true });
  }

  currentUserValue(): User {
    return this.currentUserSubject.value;
  }

  isLoggedIn(): boolean {
    return !!this.currentUserValue();
  }

  getUser(): User {
    return this.storageService.getObject(STORAGE_KEYS.USER);
  }

  get getSystemId(): number {
    return this.storageService.getObject(STORAGE_KEYS.USER).systemId;
  }

  isSystemValladolid() {
    return SYSTEMS.VALLADOLID == this.getSystemId;
  }
}
